import React from "react";
import "./style.css";

const ChampionVideos = ({ URL, title }) => {
  return (
    <div className="champ-videos">
      <div className="col-lg-11 col-12 mx-auto my-4 d-grid inner-row">
        <iframe
          width="100%"
          height="300px"
          src={URL}
        ></iframe>
        <div className="video-desc">
          <p className="video-title fw-bold mb-0 p-3">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default ChampionVideos;
